import { isUserAllowed } from '@ynap/user-state';

/**
 * Gets first valid badge with respect to the blockList passed
 * @param {Array} badges
 * @param {Array} badgeBlocklist
 * @returns {Object}
 */
export function getFirstValidBadge(badges = [], badgeBlocklist = [], segmentBadges = [], user) {
    const relevantSegmentBadge = segmentBadges.find((badge) => isUserAllowed([badge.segmentName], user));

    if (relevantSegmentBadge) {
        return relevantSegmentBadge.badges[0];
    }

    return badges.find((badge) => ['MERCHANDISING', 'STOCK'].includes(badge.type) && !badgeBlocklist.includes(badge.key));
}

/**
 * Get First Badge from list of filtered badges
 * @param {Object}
 * {
 *  badges: Array
 *  badgeBlocklist: Array
 *  pageType: string
 *  messages: Object
 *  options: { configSaleBadges: Object } brand config to determine if badge is a sale one
 *  user: Object
 *  selectedProductColour: Object
 * }
 * @returns {Object}
 */
export default function getBadge({ badgeBlocklist = [], badges = [], messages = {}, options, pageType, segmentBadges, user }) {
    const badge = getFirstValidBadge(badges, badgeBlocklist, segmentBadges, user);

    if (!badge) {
        return { label: '', type: null, key: '' };
    }

    if (options?.configSaleBadges?.[badge.key]) {
        badge.sale = true;
    }

    if (badge.key === 'BADGE_CRAFTSMANSHIP_CODE') {
        badge.craftmanship = true;
    } else if (badge.key === 'BADGE_SOLD_OUT' && pageType === 'EIP_PREVIEW') {
        return { ...badge, label: messages.contactUsCTA?.eip?.badge() };
    }

    return badge;
}

export const filterStockBadges = (badges = []) => badges.filter(({ type }) => type === 'STOCK');
